module.exports = __webpack_public_path__ + "static/media/github_icon.127505f30646a190b4c5cb61a46cdbad.svg";